import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import FeatureAppContainer from 'src/components/app-store/AppStoreAppContainer'
import AppDetailsHero from 'src/components/app-store/Single-Page/AppDetailsHero'
import { useLoader } from 'src/lib/contexts/LoaderContext'
import { getRequest } from 'src/lib/core/api-client'
import { AppStoreAppType } from 'src/lib/types/AppStoreTypes'
import { apiURI } from 'src/lib/utils/constants'
import { getFeaturedAppDetails } from 'src/lib/utils/AppStoreHelper'
import AppDetailsInfo from 'src/components/app-store/Single-Page/AppDetailsInfo'
import AppStoreLayout from 'src/components/app-store/AppStoreLayout'

const FeaturedAppDetailsPage = () => {
  const router = useRouter()
  const [appDetails, setAppDetails] = useState<AppStoreAppType>()
  const { setLoaderProperties } = useLoader()

  useEffect(() => {
    const appId = router.query.id
    const fetchAppDetails = async () => {
      setLoaderProperties({ isLoaderVisible: true, message: 'Loading app details' })
      try {
        const appData = await getRequest(`/shopflo-apps/${appId}?includes=SUBSCRIPTIONS`, apiURI.SETTLEMENT_ENGINE)
        const appDetails = getFeaturedAppDetails(appData.data)
        setAppDetails(appDetails)
        setLoaderProperties({ isLoaderVisible: false })
      } catch (error) {
        console.error('Failed to fetch app details:', error)
        router.push('/app-store') // Redirect on fetch failure
      }
    }
    if (router.query.id) fetchAppDetails()
  }, [router.query.id])

  return (
    <AppStoreLayout hideHeader={true}>
      {Boolean(router.query.id) && appDetails && (
        <>
          <AppDetailsHero appDetails={appDetails} />
          <AppDetailsInfo appDetails={appDetails} />
        </>
      )}
    </AppStoreLayout>
  )
}

export default FeaturedAppDetailsPage
